import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "../EventBus";
import PointManager from "../PointManager";
import PointTagManager from "../PointTagManager";
import AngleManager from "../AngleManager";
import LineManager from "../LineManager";
import { runCircleAnimation } from "./CircleAnimationSequence";
import Circle from "../../../../../../src/entities/Circle";
import CircleAnimationButton from "../../../../../../src/entities/UI/CircleAnimationButton/CircleAnimationButton";
import { Coord } from "../../../../../../src/types/Interface";
import { ContextType } from "../../types/Interface";
import { INFO_SLIDER_COORD } from "../../types/Config";


export default class AnimationManager {
  private isCatModeActive: boolean = false;
  private isScndModeActive: boolean = false;
  private isSegmentModeActive: boolean = false;

  constructor(
    private PointManager: PointManager,
    private PointTagManager: PointTagManager,
    private AngleManager: AngleManager,
    private LineManager: LineManager,
    private circle: Circle,
    private cCoord: Coord
  ) {
    this.addCircAnimBut();
    eventBus.on(EnumEventBus.catMode, v => this.isCatModeActive = v);
    eventBus.on(EnumEventBus.showSecondAngles, v => this.isScndModeActive = v);
    eventBus.on(EnumEventBus.segmentMode, v => this.isSegmentModeActive = v);

  }
  getDelayForStartAnim = () => (this.isCatModeActive || this.isScndModeActive) ? 1000 : this.isSegmentModeActive ? 150 : 0;
  addCircAnimBut = () => new CircleAnimationButton(INFO_SLIDER_COORD, () => this.runAnimations(), () => this.getDelayForStartAnim())

  completedCircleAnim = () => {
    rootEventBus.emit(EnumRootEventBus.getCircleCoord, { x: this.circle.x, y: this.circle.y })
    rootEventBus.emit(EnumRootEventBus.completedCircleAnim)
  }
  runAnimations() {
    rootEventBus.emit(EnumRootEventBus.startedCircleAnim);

    const context: ContextType = {
      circle: this.circle,
      LineManager: this.LineManager,
      PointManager: this.PointManager,
      PointTagManager: this.PointTagManager,
      AngleManager: this.AngleManager,
      cCoord: this.cCoord,
    }
    runCircleAnimation(context, () => this.completedCircleAnim());
  }
}
